import React from 'react';
import PropTypes from 'prop-types';

import styles from '../article.module.css';

export const StyledVideo = ({
	id,
	expandfullwidth,
	vidtype,
	bleed,
	caption,
	captionenabled,
	credit,
	creditenabled,
	vidid,
}) => {
	return (
		<Video
			id={id}
			videoId={vidid}
			type={vidtype}
			bleed={bleed === 'on'}
			expandFullWidth={expandfullwidth === 'on'}
			caption={caption}
			captionEnabled={captionenabled === 'on'}
			credit={credit}
			creditEnabled={creditenabled === 'on'}
		/>
	);
};

StyledVideo.propTypes = {
	id: PropTypes.string,
	vidid: PropTypes.string,
	expandfullwidth: PropTypes.string,
	vidtype: PropTypes.oneOf(['youtube', 'vimeo']),
	bleed: PropTypes.string,
	caption: PropTypes.string,
	captionenabled: PropTypes.string,
	credit: PropTypes.string,
	creditenabled: PropTypes.string,
};

export const Video = ({
	id,
	videoId,
	type,
	marginTop,
	marginBottom,
	bleed,
	fullWidth,
	expandFullWidth,
	caption,
	captionEnabled,
	credit,
	creditEnabled,
}) => {
	let component = null;
	const containerStyle = {
		marginTop,
		marginBottom,
	};
	const componentStyle = {};
	if (fullWidth) {
		containerStyle.minWidth = '100%';
		containerStyle.width = '100%';
	}

	if (expandFullWidth) {
		componentStyle.minWidth = '100%';
		componentStyle.width = '100%';
	}

	switch (type) {
		case 'youtube':
			component = (
				<iframe
					width="100%"
					title={'Video'}
					height="400"
					style={componentStyle}
					src={`https://www.youtube.com/embed/${videoId}`}
					frameBorder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			);
			break;
		case 'vimeo':
			component = (
				<iframe
					title={'Video'}
					src={`https://player.vimeo.com/video/${videoId}`}
					width="100%"
					height="400"
					style={componentStyle}
					frameBorder="0"
					allow="autoplay; fullscreen"
					allowFullScreen
				/>
			);
			break;
		default:
			component = null;
	}

	const className = [styles['video'], 'media'];
	if(bleed && !fullWidth) {
		className.push('bleed');
	}

	return (
		<div
			id={id}
			className={className.join(' ')}
			style={containerStyle}
		>
			{component}
			{captionEnabled && caption ? <Caption content={caption} /> : null}
			{creditEnabled && credit ? <Credit content={credit} /> : null}
		</div>
	);
};

Video.propTypes = {
	id: PropTypes.string,
	videoId: PropTypes.string.isRequired,
	type: PropTypes.string,
	bleed: PropTypes.bool,
	fullWidth: PropTypes.bool,
	expandFullWidth: PropTypes.bool,
	caption: PropTypes.string,
	captionEnabled: PropTypes.bool,
	credit: PropTypes.string,
	creditEnabled: PropTypes.bool,
	marginTop: PropTypes.number,
	marginBottom: PropTypes.number,
};

Video.defaultProps = {
	marginTop: 0,
	marginBottom: 0,
};

const Caption = ({ content }) => {
	return <figcaption dangerouslySetInnerHTML={{ __html: content }} />;
};

Caption.propTypes = {
	content: PropTypes.string,
};

Caption.defaultProps = {
	content: '',
};

const Credit = ({ content }) => {
	return (
		<cite
			className={styles['credit']}
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	);
};

Credit.propTypes = {
	content: PropTypes.string,
};

Credit.defaultProps = {
	content: '',
};
